import * as Styled from './ProcessInventory.styled';
import * as ReportingStyled from '../Reporting.styled';

export const columns = [
  {
    title: 'Process Level 1 Title',
    dataIndex: 'l1_title',
    key: 'l1_title',
    width: 200
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Process validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'l1_validity',
    onHeaderCell: () => ({
      style: Styled.processInventoryHeaderStyle
    }),
    children: [
      {
        title: ' ',
        dataIndex: 'business_process_l1_start_date',
        key: 'business_process_l1_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.processInventoryDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.processInventoryStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'business_process_l1_end_date',
        key: 'business_process_l1_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.processInventoryDateHeaderStyle
        })
      }
    ]
  },
  {
    title: 'Process Level 2 Title',
    dataIndex: 'l2_title',
    key: 'l2_title',
    width: 200
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Process validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'l2_validity',
    onHeaderCell: () => ({
      style: Styled.processInventoryHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'business_process_l2_start_date',
        key: 'business_process_l2_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.processInventoryDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.processInventoryStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'business_process_l2_end_date',
        key: 'business_process_l2_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.processInventoryDateHeaderStyle
        })
      }
    ]
  },
  {
    title: 'Process Level 3 Title',
    dataIndex: 'l3_title',
    key: 'l3_title',
    width: 200
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Process validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'l3_validity',
    onHeaderCell: () => ({
      style: Styled.processInventoryHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'business_process_l3_start_date',
        key: 'business_process_l3_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.processInventoryDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.processInventoryStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'business_process_l3_end_date',
        key: 'business_process_l3_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.processInventoryDateHeaderStyle
        })
      }
    ]
  },
  {
    title: 'Process Level 4 Title',
    dataIndex: 'l4_title',
    key: 'l4_title',
    width: 200
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Process validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'l4_validity',
    onHeaderCell: () => ({
      style: Styled.processInventoryHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'business_process_l4_start_date',
        key: 'business_process_l4_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.processInventoryDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.processInventoryStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'business_process_l4_end_date',
        key: 'business_process_l4_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.processInventoryDateHeaderStyle
        })
      }
    ]
  },
  {
    title: 'Group Name',
    dataIndex: 'group_name',
    key: 'group_name',
    width: 150
  },
  {
    title: 'Division Name',
    dataIndex: 'division_name',
    key: 'division_name',
    width: 150
  },
  {
    title: 'Region Name',
    dataIndex: 'region_name',
    key: 'region_name',
    width: 150
  },
  {
    title: 'Legal Entity Name',
    dataIndex: 'legal_entity_name',
    key: 'legal_entity_name',
    width: 180
  },
  {
    title: 'Business Unit Name',
    dataIndex: 'business_unit_name',
    key: 'business_unit_name',
    width: 180
  }
];
